(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('swifOpenbaseUserService', swifOpenbaseUserService)
    .controller('UsersController', UsersController)
    .controller('OpenbaseUserController', OpenbaseUserController)
    .controller('ResetPasswordController', ResetPasswordController)
    .controller('OpenbaseFixUsersWithoutPartner', OpenbaseFixUsersWithoutPartner)
    .directive('panelUser', panelUser)
    .directive('thumbnailUser', thumbnailUser);


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/users/table_view', {
            templateUrl: 'partials/openbase/users_table_view.html',
            controller: 'UsersController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/fix_users_withtout_partner', {
            templateUrl: 'partials/openbase/fix_users_without_partner.html',
            controller: 'OpenbaseFixUsersWithoutPartner',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseUserService
     * @description user configuration manager
     * @requires swif.framework.swifFrameworkService
     * @requires swif.openbase.swifOpenbaseGroupsService
     **/

    function swifOpenbaseUserService(swif, swifOpenbaseGroupsService, dataService) {
        'ngInject';
        var service = swifOpenbaseGroupsService;
        service.getCollection = function () {
            return swif.collection.getCollection('users');
        };
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate(
                'users', 'user', filter, {location: true}
            ).then(function (collection) {
                return collection;
            });
        };
        service.preModal = function (data) {

            if (data.action.id === 'add') {
                data.model = {};
                _.defaults(data.model, swif.settings.app.defaultValues.user);
                var group;
                service.initialize()
                .then( function () {
                    if (swif.module.modules.openstc) {
                        group = service.groupsByCode.PART;
                        data.model.current_group = [group.id, group.name];
                    }
                    if (swif.module.modules.openresa) {
                        group = service.groupsByCode.HOTEL_USER_EXT;
                        data.model.openresa_group = [group.id, group.name];
                    }
                });
                data.model.accreditation_rel_ids = [];
            }

            // Initialize accreditations
            data.model.accreditations = [];

            if (data.action.id === 'edit') {

                if (data.model.address_id && !data.model.service_id) {
                    //TODO : load the partner id
                    var params = {fields: ['partner_id']};
                    swif.data.get('partner_address', data.model.address_id[0], params)
                    .then(function (pa) {
                        data.model._partner_id = pa.partner_id;
                        if (data.model.is_supplier) {
                            data.model._partner_type = pa.partner_id;
                            data.model._is_supplier = data.model.is_supplier;
                        }
                    });
                }

                if (swif.user.getAccessRights()['openbase_configure_users_accreditations']) {
                    // Retrieve user accreditations
                    var filter = {};
                    swif.data.addFilter(filter, 'user_id', '=', data.model.id);

                    swif.data.searchRead('user_accreditation_rel', filter)
                        .then(function (accreditationRelationships) {
                            // Add each accreditation to the list
                            angular.forEach(accreditationRelationships.records, function (item) {
                                data.model.accreditations.push({
                                    accreditation: {
                                        id: item.accreditation_id[0],
                                        name: item.accreditation_id[1],
                                        has_validity_date: item.has_validity_date
                                    },
                                    date_start: item.date_start,
                                    date_end: item.date_end
                                });
                            })
                        });
                }
            }
        };
        service.preValidate = function (data, cid) {
            cid = cid || 'users';
            var ret = true;
            var collection = swif.collections.getCollection(cid);
            if (collection) {
                ret = collection.preValidate(data);
            }
            if (data.action.id === 'edit' || data.action.id === 'add') {
                if (data.model._partner_id) {
                    data.model.partner_id = data.model._partner_id;
                }
                if(data.model._partner_type){
                    data.model.partner_id = data.model._partner_type;
                    data.model.is_supplier = data.model._is_supplier;
                }
                data.model.groups_id = [];
                if (data.model.current_group) {
                    data.model.groups_id.push(data.model.current_group[0]);
                }
                if (data.model.patrimoine_group) {
                    data.model.groups_id.push(data.model.patrimoine_group[0]);
                }
                if (data.model.openresa_group) {
                    data.model.groups_id.push(data.model.openresa_group[0]);
                }
                if (data.model.achat_group) {
                    data.model.groups_id.push(data.model.achat_group[0]);
                }
                if (data.model.parcauto_group) {
                    data.model.groups_id.push(data.model.parcauto_group[0]);
                }
                if (data.model.fluids_group) {
                    data.model.groups_id.push(data.model.fluids_group[0]);
                }
                if (data.model.public_lightning_group) {
                    data.model.groups_id.push(data.model.public_lightning_group[0]);
                }
                //access_rights exposed in the view
                // to avoid access_rights inclusion problems
                [
                    'openstc_data_config',
                    'openbase_configuration_menu',
                    'openstc_patrimoine_configure_all',
                    'openresa_configure_all',
                    'openstc_achat_stock_configure_all',
                    'opengst_parcauto_configure_all',
                    'opengst_fluids_configure_all',
                    'opengst_public_lightning_configure_all',
                    'openbase_partner_all',
                    'openbase_service_all',
                    'openbase_email_template_menu',
                    'openbase_sms_template_menu',
                    'openbase_planning_menu',
                    'openbase_user_all',
                    'openbase_team_all',
                    'openbase_prestation_all',
                    'openbase_consumable_all',
                    'openbase_configure_accreditations',
                    'openbase_configure_users_accreditations',
                    'openbase_configure_site_all',
                    'openbase_configure_equipment_all',
                    'openbase_configure_budget_all',
                    'openbase_specialday_all',
                    'openbase_barcode_config',
                    'openbase_data_categ_all',
                    'openstc_employee',
                    'purchase_order_ask_base',
                    'purchase_order_ask_update'
                ].forEach((code) => {
                    if (!service.groupsByCode[code]) {
                        return;
                    }
                    if (data.model._access_rights[code] === true) {
                        data.model.groups_id.push(service.groupsByCode[code].id);
                    }
                });
                // if the user is an external supplier, gives the minimum rights to log in opengst but without modules
                if (data.model._is_supplier) {
                    data.model.groups_id = [];
                    data.model.groups_id.push(service.groupsByCode['openstc_employee'].id,
                                            service.groupsByCode['purchase_order_ask_base'].id,
                                            service.groupsByCode['purchase_order_ask_update'].id);
                }
                if (_.isEmpty(data.model.groups_id)) {
                    data.model.groups_id = false;
                }
                if (swif.user.getAuthenticatedUser().uid === data.model.id) {
                    delete data.model.groups_id;
                }

                // Accreditations

                if (swif.user.getAccessRights()['openbase_configure_users_accreditations']) {
                    // First, delete all relations
                    data.model.accreditation_rel_ids = [[5]];

                    if (data.model.accreditations && data.model.accreditations.length > 0) {
                        // Then add accreditation relations
                        angular.forEach(data.model.accreditations, function (item) {
                            data.model.accreditation_rel_ids.push([0, 0, {
                                accreditation_id: item.accreditation.id,
                                date_start: item.date_start,
                                date_end: item.date_end
                            }]);
                        })
                    }
                }

            }
            if (data.action.id === 'add') {
                _.defaults(data.model, swif.settings.app.defaultValues.user);
            }
            return ret;
        };
        service.callbackMessage = function (error, data) {
            if (error) {
                return;
            }
            swif.collections.defaultCallbackMessage(error, data);
            if (data.action.id === 'resetpassword') {
                swif.message.addInfo('Password has been changed successfully');
            }
        };
        service.callback = function (error, data) {
            service.callbackMessage(error, data);
            var collection = swif.collections.getCollection('users');
            if (error) {
                return;
            }
            if (collection) {
                collection.fasterCallback(data);
            }
            if (data.action.id === 'edit') {

            }
        };
        service.searchForUSers = function (login) {
            var params = {};
            swif.data.addFilter(params, '|');
            // swif.data.addFilter(params, '|');
            swif.data.addFilter(params, 'login', 'ilike', login);
            swif.data.addFilter(params, 'name', 'ilike', login);
            // swif.data.addFilter(params, 'firstname', 'ilike', login);
            return swif.data.get('user', undefined, params);
        };
        service.getRandomColor = function () {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        };
        service.getUserWithLogin = function (login) {
            var params = {};
            swif.data.addFilter(params, 'login', '=', login);
            return swif.data.get('user', undefined, params)
            .then(function (results) {
                if (results.length === 1) {
                    return results[0];
                } else {
                    return;
                }
            });
        };
        service.getFilters = function () {
            var modules = swif.module.modules;
            var filters = {
                group_global: {},
                group_openbase: {},
                group_openstc: {},
                group_openresa: {},
                group_openstc_patrimoine: {},
                group_openstc_achat_stock: {},
                group_opengst_fluids: {},
                group_opengst_parcauto: {},
                group_opengst_public_lightning: {},
                partner: {},
                partner_supplier: {},
                inter_service_ids: {},
                patrimoine_service_ids: {},
                parcauto_service_ids: {},
                accreditations: {},
                equipment_categories: {},
            };

            if (modules.openbase) {
                swif.data.ref('openbase.category_opengst_profile_global').then(function (ref) {
                    swif.data.addFilter(filters.group_global, 'category_id', '=', ref);
                });
                swif.data.ref('openbase.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_openbase, 'category_id', '=', ref);
                });
            }
            if (modules.openstc) {
                swif.data.ref('openstc.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_openstc, 'category_id', '=', ref);
                });
                swif.data.addFilter(
                    filters.inter_service_ids,
                    'is_assignable_to_ask', '=', true
                );
                swif.data.addFilter(
                    filters.inter_service_ids,
                    'is_assignable_to_project', '=', true
                );
                swif.data.addFilter(
                    filters.inter_service_ids,
                    'is_assignable_to_task', '=', true
                );
            }
            if (modules.openresa) {
                swif.data.ref('openresa.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_openresa, 'category_id', '=', ref);
                });
            }
            if (modules.openstc_patrimoine) {
                swif.data.ref('openstc_patrimoine.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_openstc_patrimoine, 'category_id', '=', ref);
                });
                swif.data.addFilter(
                    filters.patrimoine_service_ids,
                    'is_assignable_to_patrimoine_contract', '=', true
                );
                swif.data.addFilter(
                    filters.equipment_categories,
                    'is_key', '=', false
                );
                swif.data.addFilter(
                    filters.equipment_categories,
                    'is_vehicle', '=', false
                );
                swif.data.addFilter(
                    filters.equipment_categories,
                    'is_fluid_meter', '=', false
                );
            }
            if (modules.openstc_achat_stock) {
                swif.data.ref('openstc_achat_stock.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_openstc_achat_stock, 'category_id', '=', ref);
                });
            }
            if (modules.opengst_fluide) {
                swif.data.ref('opengst_fluids.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_opengst_fluids, 'category_id', '=', ref);
                });
            }
            if (modules.opengst_parcauto) {
                swif.data.ref('opengst_parcauto.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_opengst_parcauto, 'category_id', '=', ref);
                });
                swif.data.addFilter(
                    filters.parcauto_service_ids,
                    'is_assignable_to_ask', '=', true
                );
                swif.data.addFilter(
                    filters.parcauto_service_ids,
                    'is_assignable_to_project', '=', true
                );
                swif.data.addFilter(
                    filters.parcauto_service_ids,
                    'is_assignable_to_task', '=', true
                );
            }
            if (modules.opengst_public_lightning) {
                swif.data.ref('opengst_public_lightning.category_opengst_profile').then(function (ref) {
                    swif.data.addFilter(filters.group_opengst_public_lightning, 'category_id', '=', ref);
                });
            }
            swif.data.addFilter(filters.partner, 'is_department', '=', false);
            swif.data.addFilter(filters.partner_supplier, 'supplier', '=', true);
            return filters;
        };
        return service;
    }



    function UsersController ($controller, $scope, swif, swifOpenbaseUserService) {
        'ngInject';
        var user = swifOpenbaseUserService;
        console.log('init UsersController');
        user.initialize();
        $scope.modules = swif.module.modules;
        user.createCollection().then(function (collection) {
            $scope.users = collection;
        });
        $scope.callback = user.callback;
        $scope.preValidate = user.preValidate;
        $scope.preModal = user.preModal;
    }


    function OpenbaseUserController($scope, swif, swifOpenbaseUserService, swifOpenbaseCompanyService, swifOpenbaseLanguageService, settingsService, amMoment) {
        'ngInject';
        var user = swif.user.getAuthenticatedUserData();
        var langService = swifOpenbaseLanguageService;

        $scope.user_uid = swif.user.getAuthenticatedUser().uid; // uid is not is [...]UserData()
        $scope.settings = swif.settings;
        $scope.modules = swif.module.modules;
        $scope.filters = swifOpenbaseUserService.getFilters();
        $scope.selected = {};
        $scope.providersProfile = swif.settings.app.features.providersProfile;

        langService.getLanguages().then(languages => {
            // EN lang is not handled yet, so don't show it to users
            $scope.languages = languages.records.filter( lang => lang.code !== 'en_US');
            var langCode = settingsService.get('authenticated_user_data') ? settingsService.get('authenticated_user_data').context_lang : settingsService.app.defaultValues.user.context_lang;

            if (langCode) {
                $scope.model.context_lang = langCode;
            }
        });

        $scope.is = {
            interventions: {
                manager: _.contains(user.access_rights, 'MANA'),
                accueil: _.contains(user.access_rights, 'RCPT')
            }
        };

        $scope.show_equipment_movement_settings = $scope.settings.app.features.equipmentMovement && $scope.model.patrimoine_group && !_.contains($scope.model.patrimoine_group, 'Demandeur');

        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.request_communication_channel_enable = company.request_communication_channel_enable;
        });

        if (_.isEmpty($scope.model.service_id)) {
            $scope.model._is_member = false;
        } else {
            $scope.model._is_member = true;
        }

        $scope.setOriginalLogin = setOriginalLogin;
        $scope.isOriginalLogin = isOriginalLogin;
        if (_.isUndefined($scope.model.id)) {
            $scope.model.hex_color = swifOpenbaseUserService.getRandomColor();
        }
        //preferences modal
        $scope.options = {
            timezone: moment.tz.names()
        };
        $scope.setServiceIds = setServiceIds;
        //add support for access_rights serialization
        /**
            model._access_rights = {
                openbase_configuration_menu: true / false,
                ..
            }
            model.implied_ids = [23,43, ...]
        **/
        if (!$scope.model._access_rights) {
            $scope.model._access_rights = {};
        }
        $scope.set_access_rights_to_groups = function () {
            swifOpenbaseUserService.set_access_rights_to_groups($scope.model._access_rights, $scope.model.groups_id, false);
        };
        $scope.groups_id_to_access_rights = function () {
            swifOpenbaseUserService.groups_id_to_access_rights($scope.model.groups_id, $scope.model._access_rights);
        };
        $scope.groups_id_to_access_rights();


        $scope.onSelectWarehouse = (item) => {
            let warehouseFilter = { fields: ['id'] };
            swif.data.addFilter(warehouseFilter, 'id', 'child_of', item.id);
            swif.data.get('stock_warehouse', undefined, warehouseFilter).then(function (data) {
                $scope.model.warehouse_ids = _.uniq([...$scope.model.warehouse_ids, ...data.map(x => x.id)])
            })
        }

        $scope.$watch('model.login', watchLogin);
        $scope.$watch('model._is_member', watchIsMember);
        $scope.$watch('model._is_supplier', watchIsSupplier);
        $scope.$watch('model.can_manage_equipment_move', watchManageEquipmentMovement);

        //TODO check if login already exists during add
        function alreadyExist (login) {
            swifOpenbaseUserService.getUserWithLogin(login)
            .then(function (user) {
                if (user) {
                    $scope.already_exist = true;
                    $scope.user = user;
                } else {
                    $scope.already_exist = false;
                    delete $scope.user;
                }
            });
        }
        var originalLogin = $scope.model.login;

        function setOriginalLogin() {
            $scope.model.login = originalLogin;
        }
        function isOriginalLogin () {
            if (originalLogin) {
                return $scope.model.login === originalLogin;
            } else {
                return true;
            }
        }
        function watchLogin(newV) {
            if (newV) {
                if (newV !== originalLogin) {
                    alreadyExist(newV);
                } else {
                    $scope.already_exist = false;
                    delete $scope.user;
                }
            }
        }
        function watchIsMember(newV) {
            if (newV === true) {
                $scope.model._partner_id = false;
                $scope.model._partner_type = false;
            } else if (newV === false) {
                $scope.model.service_id = false;
                $scope.model.service_ids = false;
            }
        }
        function watchIsSupplier(newV) {
            if (newV === true) {
                $scope.model._partner_id = false;
                $scope.model.service_id = false;
                $scope.model.service_ids = false;
            } else if (newV === false) {
                $scope.model._partner_type = false;
            }
        }
        function watchManageEquipmentMovement(newV) {
            if (newV === false) {
                $scope.model.equipment_categories_ids = undefined;
            }
        }
        function setServiceIds (departmentIs) {
            var params = {fields: ['id']};
            swif.data.addFilter(params, departmentIs, '=', true);
            swif.data.searchRead('department', params).then(function(data) {
                var alreadyIn = $scope.model.service_ids;
                _.forEach(data.records, function (record) {
                    if (!_.contains(alreadyIn, record.id)) {
                        if (!$scope.model.service_ids) {
                            $scope.model.service_ids = [];
                        }
                        $scope.model.service_ids.push(record.id);
                    }
                });
            });
        }

        // ---- Accreditations ----

        /**
         * Add the accreditation to the selected ones
         **/
        $scope.onAccreditationChange = function (selection) {
            if (selection.id) {
                // Retrieve accreditation details
                swif.data.get('accreditation', selection.id)
                    .then(function (accreditation) {
                        // Append the accreditations
                        $scope.model.accreditations.push({
                            accreditation: accreditation,
                            date_start: null,
                            date_end: null
                        });

                        // Reset selection
                        delete $scope.selected.accreditation;
                    });
            }
        };

        /**
         * Remove the accreditation at the given index
         **/
        $scope.deleteAccreditation = function (index) {
            $scope.model.accreditations.splice(index, 1);
        };

        /**
         * Watch for accreditation changes and update the exclude filter
         * to avoid duplicate accreditations
         **/
        $scope.$watch('model.accreditations', function (accreditations) {
            // Extract accreditation ids
            var accreditationIds = _.map(accreditations, 'accreditation.id');

            // Reset filter
            $scope.filters.accreditations = {};

            // Add exclude filter
            if (accreditationIds.length > 0) {
                swif.data.addFilter(
                    $scope.filters.accreditations, 'id', 'not in', accreditationIds);
            }
        }, true);

        $scope.$watch('model.patrimoine_group', function (newV) {
            if (newV && _.isArray(newV)) {
                $scope.show_equipment_movement_settings = $scope.settings.app.features.equipmentMovement && !_.contains(newV, 'Demandeur');
            }
        });
    }

    function ResetPasswordController($scope) {
        'ngInject';
        console.log('init ResetPasswordController');
        $scope.is_valid_password = true;
        $scope.$watch('model', function (newV) {
            if (newV === undefined) {
                return;
            }
            if (newV.new_password && newV.new_password_copy) {
                if (newV.new_password_copy === newV.new_password) {
                    $scope.is_valid_password = true;
                    $scope.form.$setValidity('PasswordEquality', true);
                } else {
                    $scope.is_valid_password = false;
                    $scope.form.$setValidity('PasswordEquality', false);
                }
            } else {
                $scope.is_valid_password = true;
                $scope.form.$setValidity('PasswordEquality', true);
            }
        }, true);

    }

    function OpenbaseFixUsersWithoutPartner ($scope, $q, swif) {
        'ngInject';
        console.log('init OpenbaseFixUsersWithoutPartner');
        $scope.partnerAddressByUserId = {};
        $scope.userByPartnerId = {};
        var filter = {
            limit: 0,
            fields: ['id', 'name', 'login', 'address_id', 'contact_id', 'partner_id']
        };
        swif.data.addFilter(filter, 'service_ids', '=', false);
        swif.data.addFilter(filter, 'address_id.partner_id', '=', false);
        swif.collection.createOrUpdate(
            'fixusers',
            'user',
            filter, {limitPerPage: 0}
        ).then(function (collection) {
            $scope.users = collection;
        });
        $scope.$watch('users.items', function (newV) {
            if (!newV) {
                return;
            }
            var address_ids = [];
            //TODO: {pa_id: user}
            _.forEach(newV, function (user) {
                _.forEach(user.contact_id, function (id) {
                    address_ids.push(id);
                    $scope.userByPartnerId[id] = user;
                });
                if (user.address_id) {
                    address_ids.push(user.address_id[0]);
                    $scope.userByPartnerId[user.address_id[0]] = user;
                }
            });
            address_ids = _.uniq(address_ids);
            var params = {fields: ['id', 'name', 'partner_id', 'user_id']};
            swif.data.addFilter(params, 'id', 'in', address_ids);
            swif.data.searchRead('partner_address', params)
            .then(function (partner_addresses) {
                _.forEach(partner_addresses.records, function (pa) {
                    var user = $scope.userByPartnerId[pa.id];
                    if (!$scope.partnerAddressByUserId[user.id]) {
                        $scope.partnerAddressByUserId[user.id] = [];
                    }
                    $scope.partnerAddressByUserId[user.id].push(pa);
                });
            });
        });
        $scope.fixOne = function (user, ui) {
            var addresses = $scope.partnerAddressByUserId[user.id];
            var is_fixed = false;
            _.forEach(addresses, function (address) {
                if (address.partner_id) {
                    user.address_id = [address.id, address.name];
                    is_fixed = true;
                }
            });
            if (is_fixed) {
                swif.data.save('user', user.id, {address_id: user.address_id})
                .then(function () {
                    if (ui) {
                        swif.message.addInfo('fixed');
                    }
                });
            } else {
                $scope.fixTwo(user, ui);
            }
        };
        $scope.fixTwo = function (user, ui) {
            //find anoter partner with the same name without user?
            var filter = {};
            swif.data.addFilter(filter, 'name', '=', user.name);
            swif.data.addFilter(filter, 'id', '!=', user.address_id[0]);
            swif.data.addFilter(filter, 'partner_id', '!=', false);
            swif.data.addFilter(filter, 'user_id', '=', false);
            swif.data.searchRead('partner_address', filter)
            .then(function (addresses) {
                _.forEach(addresses.records, function (address) {
                    $scope.partnerAddressByUserId[user.id].push(address);
                });
                if (addresses.records.length === 1) {
                    var add = addresses.records[0];
                    return swif.data.save('user', user.id, {address_id: [add.id, add.name]})
                    .then(function () {
                        if (ui) {
                            swif.message.addInfo('fixed');
                        }
                    });
                } else {
                    if (ui) {
                        swif.message.addInfo('no partner found');
                    }
                    return $q.when(true);
                }
            });
        };
        $scope.fixAll = function () {
            _.forEach($scope.users.items, function (user) {
                $scope.fixOne(user);
            });
        };
    }




    function panelUser (swif) {
        'ngInject';
        var directive = swif.panel.create_directive('user');
        directive.templateUrl = 'partials/openbase/panel-user.html';
        var link = directive.link;
        directive.link = function (scope, element, attr, ngModel) {
            link(scope, element, attr, ngModel);
            scope.loading.partner_address = {};

            scope.displayPartnerAddress = false;
            scope.toggleDisplayContact = function () {
                scope.displayPartnerAddress = !scope.displayPartnerAddress;
                if (scope.displayPartnerAddress && !scope.partner_address) {
                    scope.getPartnerAddress();
                }
            };
            scope.getPartnerAddress = function () {
                if (!scope.item) {
                    scope.displayPartnerAddress = false;
                    delete scope.partner_address;
                    return;
                }
                if (!scope.item.contact_id) {
                    scope.displayPartnerAddress = false;
                    delete scope.partner_address;
                    return;
                }
                var id = scope.item.contact_id[0];
                if (scope.partner_address) {
                    if (scope.partner_address.user_id === id) {
                        return;
                    }
                }
                swif.message.loading(scope.loading.partner_address);
                swif.data.get('partner_address', id)
                .then(function (partner) {
                    swif.message.loading(scope.loading.partner_address, 'ok');
                    scope.partner_address = partner;
                }, function () {
                    swif.message.loading(scope.loading.partner_address, 'ko');
                    scope.displayPartnerAddress = false;
                    delete scope.partner_address;
                });

            };
        };
        return directive;
    }

    function thumbnailUser (swif) {
        'ngInject';
        var filter = {fields: ['name', 'function', 'service_id', 'has_image', 'partner_id']};
        var ret = swif.panel.create_directive('user', filter);
        ret.scope.light = '=?';
        ret.templateUrl = 'partials/openbase/thumbnail-user.html';
        return ret;
    }

})();
